import { render } from "./SecurityScan.vue?vue&type=template&id=764d44b2"
import script from "./SecurityScan.vue?vue&type=script&lang=js"
export * from "./SecurityScan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__